import localForage from 'localforage';

import { getClient } from 'lane-shared/apollo';
import { signOut } from 'lane-shared/graphql/user';
import { getSessionId } from 'lane-shared/helpers/auth0/getSessionId';
import { isNotLoggedInError } from 'lane-shared/helpers';

import emitter, {
  EVENT_LOGOUT,
  EVENT_AUTH_TOKEN_INVALID,
} from 'lane-shared/helpers/emitter';
import { ENVIRONMENTS } from 'constants-activate';

import { GetAuthTokenResponse } from 'lane-shared/types/auth0/getAuthTokenResponseType';

type LogoutOptions = {
  emitLogout?: boolean;
  emitAuthTokenInvalid?: boolean;
};

export default async function logout(
  getAuthToken: GetAuthTokenResponse,
  { emitLogout = true, emitAuthTokenInvalid = true }: LogoutOptions = {}
) {
  const token = await getAuthToken();

  const disconnectFromAPI = async (
    token: string | { token: string; jti: string }
  ) => {
    const sessionId = getSessionId(token);

    await getClient().mutate({
      mutation: signOut,
      variables: { jti: sessionId },
    });
    getClient().cache.reset();
  };

  const isAuth0SimulatorEnabled =
    process.env.APP_ENV === ENVIRONMENTS.LOCAL ||
    process.env.APP_ENV === ENVIRONMENTS.TEST;

  if (!isAuth0SimulatorEnabled && token) {
    try {
      await disconnectFromAPI(token);
    } catch (error) {
      if (!isNotLoggedInError(error)) {
        throw error;
      }
    }
  }

  localForage.clear().catch(() => undefined);

  if (emitLogout) {
    emitter.emit(EVENT_LOGOUT);
  }

  if (emitAuthTokenInvalid) {
    emitter.emit(EVENT_AUTH_TOKEN_INVALID);
  }
}
